import React from 'react';
import messages from './messages';
import mountTrackerFactory from '../../../../common/analytics/mount-tracker-factory';
import BaseUnknownError from '../../common/base-unknown-error';

const MountTracker = mountTrackerFactory('PageTreeUnknownError');

const PageTreeUnknownError = () => (
	<>
		<BaseUnknownError messages={messages} />
		<MountTracker />
	</>
);

export default PageTreeUnknownError;
